/**
 * Forces a colour to full opacity (alpha 1).
 */
export default function toOpaqueColor(color: string | undefined): string | undefined {
	if (!color) return color;
	const value = color.trim();

	const rgbaMatch = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
	if (rgbaMatch) {
		return `rgb(${rgbaMatch[1]}, ${rgbaMatch[2]}, ${rgbaMatch[3]})`;
	}

	if (/^#[0-9a-f]{8}$/i.test(value)) return value.slice(0, 7); // #RRGGBBAA -> #RRGGBB
	if (/^#[0-9a-f]{4}$/i.test(value)) return value.slice(0, 4); // #RGBA -> #RGB

	return value;
}
